import {Avatar} from 'antd'
import {organization_Edit_Api} from 'apis'
import {getId} from 'apis/model/base'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import createEditableForm from 'views/AppLocals/factory/createEditableForm'
import {yupShape,} from 'views/AppLocals/factory/createValidationSchema'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import OrganizationContainerContext from 'views/AppLocals/Organization/OrganizationContainerContext'
import Translate from "../../../../modules/local/Translate";
import {renderIf, renderIfElse} from "../../../Shared";
import {MdAccountBalance, MdChurch} from "react-icons/md";
import {RiMapPinFill} from "react-icons/ri";
import {OrgType2Association} from "../consts/AssociationStatus";
import {getType} from "../../../../apis/model/base";
import {ItemInformation} from 'components/common/ItemInformation'
import {GenderTypes} from "../../appFieldTypes";
import {ReligiousFillSvg} from "../../../../components/Svgs/ReligiousIconSvg";
import EmptyHolder from "../../../../components/EmptyHolder";
import {BiSolidChurch, BiUnlink} from "react-icons/bi";
import {TbBuildingChurch} from "react-icons/tb";
import AssociationHierarchyTree from './Associations/AssociationHierarchyTree'
import AssociationDeclarePanel from './Associations/AssociationDeclarePanel'
import AssociationStatusBanner, {AssociationStatusBadge} from './Associations/AssociationStatusHeader'
import AssociationBenefitsList from './Associations/AssociationBenefitsList'
import {
    getAssociationAncestorNodes,
    getAssociationBenefits,
    getAssociationFinalNodeLabel,
} from './Associations/associationHierarchyConfig'

const formFields = [
    {name: 'association'},
]

// Icon đại diện cho node cuối (chính tổ chức đang khai báo) trên cây, theo từng org_type.
const getFinalNodeIcon = (associationTypeValue) => {
    switch (associationTypeValue) {
        case 'parish':
            return <BiSolidChurch size={13}/>
        case 'deanery':
            return <MdAccountBalance size={13}/>
        case 'diocese':
            return <TbBuildingChurch size={13}/>
        case 'religious_order':
            return <ReligiousFillSvg size={12}/>
        default:
            return <MdChurch size={13}/>
    }
}

// Trạng thái tổng hợp cho toàn bộ trang, suy ra từ (association đã chọn?) + association_status -
// nguồn sự thật DUY NHẤT, mọi sub-component (banner, badge, tree, panel) đều đọc lại từ đây, tránh
// mỗi nơi tự suy luận 1 kiểu.
const resolveAssociationStatus = (association, association_status) => {
    if (!association) return 'empty'
    if (Number(association_status) === 1) return 'connected'
    if (Number(association_status) === -2) return 'rejected'
    return 'pending'
}

// `type` truyền vào ĐÃ LÀ associationTypeValue ('parish'/'diocese'/'religious_order' - xem
// _.get(OrgType2Association, org_type)?.value), không phải org_type dạng số nữa - trước đây hàm này
// tự tra lại OrgType2Association[type] (đúng khi call site còn truyền org_type số như bản gốc), từ
// khi AssociationDeclareWizard truyền thẳng associationTypeValue thì tra nhầm key ("parish" không
// khớp key "300"/"302"/"400") -> luôn rơi vào nhánh `default`, mất hết Giáo hạt/Giáo phận hiển thị
// trong danh sách kết quả tìm kiếm. Dùng thẳng `type`, không tra lại.
const renderOption = (type, o, isLg) => {

    const gender = _.find(GenderTypes, {value: o?.target_gender || o?.parent?.target_gender})?.label

    let _type  = type
    let option

    switch (_type) {
        case 'parish':
            option = (
                <div className="p-2 flex items-center flex-1 gap-3">
                    {isLg && (
                        <Avatar
                            size={50}
                            src={o.avatar}
                            className="flex flex-center background-200 rounded-lg"
                            icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                        />
                    )}
                    <div className="flex flex-col flex-1 gap-0.5">
                        <span className="font-bold text-sm text-color-000 leading-snug">
                            {o?.fullname}
                        </span>
                        {/* Giáo hạt + Giáo phận: tên giáo xứ hay trùng nhau giữa nhiều nơi (vd nhiều
                            "Giáo xứ Thánh Giuse") - chỉ hiện Giáo phận (như trước) không đủ phân biệt,
                            phải có cả Giáo hạt mới biết chính xác đang chọn giáo xứ nào. */}
                        {renderIf(
                            o?.deanery_fullname || o?.diocese_fullname,
                            <span className="font-medium text-xs text-blue-500 italic leading-snug">
                                {[o?.deanery_fullname, o?.diocese_fullname].filter(Boolean).join(' · ')}
                            </span>
                        )}
                        {renderIf(
                            o?.location_address,
                            <div className="space-x-1">
                                <RiMapPinFill size={11} className="text-color-400"/>
                                <span className="text-xs text-color-400 italic leading-snug">
                                    {o?.location_address}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            )
            break
        case 'deanery':
            option = (
                <div className="p-2 flex items-center flex-1 gap-3">
                    {isLg && (
                        <Avatar
                            size={50}
                            src={o.avatar}
                            className="flex flex-center background-200 rounded-lg"
                            icon={<MdAccountBalance size={26} style={{color: '#dddddd'}}/>}
                        />
                    )}
                    <div className="flex flex-col flex-1 gap-0.5">
                        <span className="font-bold text-sm text-color-000 leading-snug">
                            {o?.fullname}
                        </span>
                        {/* Giáo phận: 1 tỉnh/thành có thể có nhiều Giáo hạt trùng tên gợi nhớ (ít gặp
                            hơn giáo xứ nhưng vẫn cần phân biệt), hiện luôn Giáo phận trực thuộc. */}
                        {renderIf(
                            o?.diocese_fullname,
                            <span className="font-medium text-xs text-blue-500 italic leading-snug">
                                {o?.diocese_fullname}
                            </span>
                        )}
                    </div>
                </div>
            )
            break
        case 'diocese':
            option = (
                <div className="p-2 flex items-center flex-1 gap-3">
                    {isLg && (
                        <Avatar
                            size={50}
                            src={o.avatar}
                            className="flex flex-center background-200 rounded-lg"
                            icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                        />
                    )}
                    <div className="flex flex-col flex-1 gap-1">
                        <div className="space-x-1">
                            <span className="font-bold text-sm text-color-000 leading-snug">
                                {o?.fullname}
                            </span>
                        </div>
                        {renderIf(
                            o?.location_address,
                            <div className="space-x-1">
                                <RiMapPinFill size={11} className="text-color-400"/>
                                <span className="text-xs text-color-400 italic leading-snug">
                                    {o?.location_address}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            )
            break
        case 'religious_order':
            option = (
                <Translate>
                    {(t) => (
                        <div className="p-2 flex items-center flex-1 gap-3">
                            {isLg && (
                                <Avatar
                                    size={50}
                                    src={o.avatar}
                                    className="flex flex-center background-200 rounded-lg"
                                    icon={<ReligiousFillSvg size={30} className="text-color-500"/>}
                                />
                            )}
                            <div className="flex flex-col flex-1 gap-1">
                                <div className="space-x-1">
                                    <span className="font-medium text-sm text-primary-600 italic leading-snug">
                                        {`( ${o?.short_name} )`}
                                    </span>
                                    <span className="font-bold text-sm text-color-000 leading-snug">
                                        {` - ${o?.name}`}
                                    </span>
                                </div>
                                {renderIfElse(
                                    !!o?.religious_order_group,
                                    <div className="flex items-baseline gap-x-1">
                                        <ItemInformation
                                            label="religious order group"
                                            value={t(o?.religious_order_group || '')}
                                            className="text-xs"
                                        />
                                        <span className="font-bold text-xs text-blue-500 italic leading-tight">
                                            {` - ${t(gender)}`}
                                        </span>
                                    </div>,
                                    <div className="flex items-baseline gap-x-1">
                                        <ItemInformation
                                            label="the branch congregation of"
                                            value={o?.parent?.name}
                                            className="text-xs"
                                        />
                                        <span className="font-bold text-xs text-blue-500 italic leading-tight">
                                            {` - ${t(gender)}`}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </Translate>

            )
            break
        default:
            option = (
                <Translate>
                    {(t) => (
                        <div className="flex items-center flex-1 gap-3">
                            {isLg && (
                                <Avatar
                                    size={50}
                                    src={o.avatar}
                                    className="flex flex-center background-200 rounded-lg"
                                    icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                />
                            )}
                            <div className="flex flex-col">
                                <span className="font-bold text-sm text-color-000 leading-snug">
                                    {o?.name}
                                </span>
                                <span className="font-medium text-xs text-blue-500 italic leading-snug">
                                    {t(getType(o))}
                                </span>
                            </div>
                        </div>
                    )}
                </Translate>
            )
            break
    }
    return option
}

// Nội dung chính - thay cho khối form đơn (LookupField + status text) trước đây bằng bộ 3 màn hình
// (chưa liên kết / chờ duyệt / đã duyệt) có wizard khai báo + cây phân cấp trực quan, theo đúng thiết
// kế mockup: banner trạng thái (nếu có) > lưới 2 cột (khai báo/thông tin đã khoá + quyền lợi | cây
// phân cấp) - mobile-first: 1 cột, xếp cây xuống dưới trên màn hình nhỏ.
const AssociationSystemLinkPanel = ({name, value, form}) => {
    const t = useTranslate()
    const [isEditing, setIsEditing] = useState(false)
    // organization: đọc thẳng qua Context (không qua Formik values) - cần idname/id/_type nguyên gốc
    // để bấm vào node "Tổ chức của bạn" trên cây đi thẳng về trang tổ chức, không phải chỉ vài field
    // đã được `initialized()` chọn lọc vào form values.
    const {organization} = useContext(OrganizationContainerContext)

    const associationTypeValue = _.get(OrgType2Association, form?.values?.org_type)?.value
    const association = form?.values?.association
    const status = resolveAssociationStatus(association, form?.values?.association_status)

    const ancestorNodes = useMemo(
        () => getAssociationAncestorNodes(associationTypeValue, association),
        [associationTypeValue, association]
    )
    const pathLabel = ancestorNodes.map((n) => n.name).join(' > ')
    const finalNodeLabel = getAssociationFinalNodeLabel(associationTypeValue)
    const benefitKeys = getAssociationBenefits(associationTypeValue)

    return (
        <div className="flex flex-col gap-3">
            {/* Mobile-first: tiêu đề dài (uppercase, hay xuống 2 dòng) + badge trạng thái không đủ
                chỗ chung 1 hàng trên màn hình hẹp -> mặc định xếp DỌC (flex-col), chỉ lên hàng ngang
                từ sm trở lên. Xem nguyên tắc chung ở docs/ui/design-principles.md. */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <h1 className="font-bold text-xl text-color-800 uppercase tracking-wide">
                    {t('system link and verification')}
                </h1>
                <div>
                    <AssociationStatusBadge status={status}/>
                </div>
            </div>

            {renderIf(
                status !== 'empty' && !isEditing,
                <AssociationStatusBanner
                    status={status}
                    name={association?.fullname || association?.name}
                    pathLabel={pathLabel}
                    isSubmitting={form?.isSubmitting}
                    onEditRequest={() => setIsEditing(true)}
                />
            )}

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">
                <div className="flex flex-col gap-4">
                    <AssociationDeclarePanel
                        form={form}
                        name={name}
                        status={status}
                        associationTypeValue={associationTypeValue}
                        renderOption={renderOption}
                        pathLabel={pathLabel}
                        isSubmitting={form?.isSubmitting}
                        isEditing={isEditing}
                        setIsEditing={setIsEditing}
                    />
                    <AssociationBenefitsList benefitKeys={benefitKeys}/>
                </div>

                <AssociationHierarchyTree
                    nodes={ancestorNodes}
                    finalIcon={getFinalNodeIcon(associationTypeValue)}
                    currentOrg={organization}
                    finalNode={{
                        label: finalNodeLabel,
                        name: association?.fullname || association?.name,
                        status,
                    }}
                />
            </div>
        </div>
    )
}

const formSchema = [
    {
        children: [
            {
                name: 'association_type_parish',
                component: ({name, value, form}) => (
                    <AssociationSystemLinkPanel name={name} value={value} form={form}/>
                ),
            },
        ],
    },
]

const OrganizationSettingAssociations = () => {
    const t = useTranslate()

    const {organization} = useContext(OrganizationContainerContext)

    const id = getId(organization)


    const validationSchema = useMemo(
        () =>
            yupShape({}),
        [t]
    )

    const initialized = useCallback(
        ({...values}) => ({
            org_type: organization?.org_type,
            association: organization?.association,
            association_id: organization?.association?.id,
            association_type: getType(organization?.association),
            association_name: organization?.association?.name,
            association_status: organization?.association_status,
            ...values,
        }),
        []
    )

    const onPreSubmit = ({
                             association,
                             ...values
                         }) => {
        return {
            ...values,
        }
    }

    if (_.isEmpty(organization)) return null

    if (!_.get(OrgType2Association, organization.org_type)?.enabled) {
        return (
            <EmptyHolder
                icon={() => <BiUnlink size={80} style={{ color: '#e6e6e6' }}/> }
                className="border border-color-50 rounded-lg my-12 px-8"
                title="link organization"
                subTitle="link organization description"
            />
        )
    }

    return createEditableForm(
        formFields,
        formSchema
    )({
        validationSchema,
        item: {
            ...organization,
        },
        query: bindQueryParam({
            id,
        }),
        onPreSubmit,
        initialized,
        apiInfo: organization_Edit_Api,
        useDefaultActionBar: false,
    })
}

export default OrganizationSettingAssociations
